import * as React from 'react';

import Logger from 'js/app/loggerSingleton';

class CourseraToolbarErrorBoundary extends React.Component<{ children: React.ReactNode }, { hasError: boolean }> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    Logger.error('Coursera toolbar failed to load:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return null; // Silently fail for coursera toolbar
    }

    return this.props.children;
  }
}

export default CourseraToolbarErrorBoundary;
